import { Badge } from '@shared/components';
import { UNSPLIT_LABEL, unsplitBadgeLabel } from '../../../../utils/fundStatementLabels';

interface Props {
    postings?: number;
}

export function UnsplitBadge({ postings }: Props) {
    return <Badge variant="warning">{postings === undefined ? UNSPLIT_LABEL : unsplitBadgeLabel(postings)}</Badge>;
}
